const NOTI_CONSTANT = {
  SKIP: 'SKIP',
  CHANGE: 'CHANGE',
  VOLUME_CHANGED: 'VOLUME',
  ADD: 'ADD',
  FULLSCREEN: 'FULLSCREEN',
  DELETE: 'REMOVE',
  SIGNAGE: 'SIGNAGE',
};

export default NOTI_CONSTANT;
